import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Col, UiCenter, UiPrimaryButton, UiText, useBreakpointValue } from "~/components/elements";
import { PageLayout } from "~/components/layouts/PageLayout";
import { useAppDispatch, useAppSelector, useRequestState } from "~/hooks";
import { DashboardMainBox } from "~/components/shared/DashboardMainBox";
import { ShareBox } from "~/pages/result-detail/components/ShareBox";
import { fetchSharedJob } from "~/redux/dashboards/thunk";
import { TrackedSharedImagesGallery } from "~/pages/shared/VotingGallery";
import { PAGES } from "~/constants";
import isEmpty from "lodash/isEmpty";

export default function SharedJobPage() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const jobItemData = useAppSelector(state => state.dashboard.jobItemData);

  const { loading } = useRequestState(fetchSharedJob);

  const params: { slugId: string } = useParams();
  const { slugId } = params;
  const sharedJobData = useAppSelector(state => state.dashboard.sharedJobData);

  const vrTitle = useBreakpointValue<any>({ base: "headline3", sm: "headline2" });

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchSharedJob({ slug: slugId }));
    };
    if (slugId) {
      fetchData();
    }
  }, [dispatch, slugId]);

  return (
    <PageLayout
      metaTagsConfig={{
        metas: [{ name: "robots", content: "noindex,nofollow" }],
      }}
      as={Col}
      flex={1}
    >
      <Col flex={1} justify="center">
        <UiCenter p={4}>
          <DashboardMainBox>
            <Col w="full" py={10}>
              <UiText vr={vrTitle} textAlign="center" mt={8}>
                Share your favorite photos
              </UiText>
              <UiText vr="body1" textAlign="center" mt={3} mb={8}>
                Send this page to your friends & family to see what they think!
              </UiText>
              <TrackedSharedImagesGallery
                /* @ts-ignore */
                images={sharedJobData?.result_images || []}
                loading={loading}
                emptyMessage="You do not have any favourited photos!"
              />
              {sharedJobData?.result_images?.length && <ShareBox mt={8} job={sharedJobData} />}
              <UiPrimaryButton
                mt={4}
                mx="auto"
                w="full"
                maxW={{ base: undefined, md: "16.25rem" }}
                variant="outline"
                borderColor="darkblue"
                bg="transparent"
                color="darkblue"
                _hover={{
                  bg: "transparent",
                  color: "darkblue",
                }}
                onClick={() => {
                  // Dirty approach to go back to the previous page. Per this change request is too rush
                  if (isEmpty(jobItemData)) {
                    history.push(PAGES.VIEW_RESULTS);
                  } else {
                    history.goBack();
                  }
                }}
              >
                <UiText vr="title1" color="darkblue">
                  Back to your photos
                </UiText>
              </UiPrimaryButton>
            </Col>
          </DashboardMainBox>
        </UiCenter>
      </Col>
    </PageLayout>
  );
}
